import { Route, Routes } from 'react-router-dom';
import useWebSocket, { ReadyState } from "react-use-websocket"
import { useRecoilState } from 'recoil';
import { useEffect, useState } from 'react';
import ManualList from './ManualList';
// import ManualSelector from './ManualSelector';
import SpecialEquipments from './SpecialEquipments';
import Manual from './Manual';
import Trainings from './Trainings';
import Certification from './Certification';
import Appointments from './Appointments';
import Leave from './Leave';
import Menu from './Menu';
import Nav from './Nav';
// import Faq from './Faq';
import menuAtom from '../atoms/menuAtom';
import ProfileSetting from './ProfileSetting';
// import AppointmentDetails from './AppointmentDetails';
import registerServiceWorker from '../swReg';
import locationTimerAtom from '../atoms/locationTimerAtom';
import myInfoAtom from '../atoms/myInfoAtom';
// import Holidays from './Holidays';
import loaderStateAtom from '../atoms/loaderStateAtom';
import Loader from './Loader';
import uiConfigAtom from '../atoms/uiConfigAtom';
import MakeSelector from './MakeSelector';
import ModelSelector from './ModelSelector';
import clientstateAtom from '../atoms/clientsStateAtom';
import locationStateAtom from '../atoms/locationStateAtom';
import notificationStateAtom from '../atoms/notificationStateAtom';
import Notification from './Notification';
import CourseDescription from './CourseDescription';
import ChatGpt from './ChatGpt';
import CreateNewAppointment from './CreateNewAppointment';
import PaymentMode from './PaymentMode';
import PaymentConfirmation from './PaymentConfirmation';
import TapToPay from './TapToPay';
import PaymentPage from './PaymentPage';
import PaymentSuccessful from './PaymentSuccessful';
import AppointmentDetails from './AppointmentDetails';
import TotalEstimatePreview from './TotalEstimatePreview';
import ChatSupport from './ChatSupport';

function Home() {
    const [ showMenu, setShowMenu ] = useRecoilState(menuAtom)
    const [ showNotification, setShowNotification ] = useRecoilState(notificationStateAtom);
    const [ locationTimer, setLocationTimer ] = useRecoilState(locationTimerAtom);
    const [ info, setInfo ] = useRecoilState(myInfoAtom);
    const [ workerConnected, setWorkerConnected ] = useState(localStorage.getItem('workerConnected'))
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom)
    const [ uiConfig, setUiConfig ] = useRecoilState(uiConfigAtom)
    const [ clients, setClients ] = useRecoilState(clientstateAtom)
    const [ myLocation, setMyLocation ] = useRecoilState(locationStateAtom)

    const style = {
        backgroundColor: uiConfig?.primaryColor?.hex
    }

    const wsUrl = "wss://ku2qk0olw0.execute-api.us-east-1.amazonaws.com/production/";
    const { sendJsonMessage, lastJsonMessage, readyState } = useWebSocket(
        wsUrl,
        {
          share: false,
          shouldReconnect: () => true,
        },
    )

    useEffect(() => {
        console.log('running use')
        navigator.geolocation.getCurrentPosition((location, err) => {
            if(err) {
                console.log(err)
            } else {
                const { latitude, longitude } = location.coords
                setMyLocation({latitude, longitude})
            }
        }
        )
    }, [])

    useEffect(() => {

        // if (readyState === ReadyState.OPEN && locationTimer === null && info?.data?.id && clients.length !== 0) {
        //     let interval = setInterval(() => {
        //         navigator.geolocation.getCurrentPosition((location, err) => {
        //             if(err) {
        //                 console.log(err)
        //             } else {
        //                 const { latitude, longitude } = location.coords
        //                 setMyLocation({latitude, longitude})
        //                 console.log('Sending location')
        //                 console.log(clients)
        //                 sendJsonMessage({
        //                     action: 'send_location',
        //                     location: {latitude, longitude, id: info.data.id},
        //                     clients
        //                     // clients: [{id: 1, type: 'manager'}, {id: 1, type: 'customer'}]
        //                 })
        //             }
        //         })
        //     }, 30000);
        //     setLocationTimer(interval);
        //     console.log('Interval set!')
        // }
    }, [readyState])

    useEffect(() => {
        // if(locationTimer !== null ) {
            
            if (readyState === ReadyState.OPEN && info?.data?.id && clients.length !== 0) {
                clearInterval(locationTimer);
                console.log('initiating client reload!')
                let interval = setInterval(() => {
                    navigator.geolocation.getCurrentPosition((location, err) => {
                        if(err) {
                            console.log(err)
                        } else {
                            const { latitude, longitude } = location.coords
                            setMyLocation({latitude, longitude})
                            console.log('Sending location')
                            console.log(clients)
                            const message = {
                                action: 'send_location',
                                location: {latitude, longitude, id: info.data.id},
                                clients: clients
                                // clients: [{id: 1, type: 'manager'}, {id: 1, type: 'customer'}]
                            }
                            console.log(message)
                            sendJsonMessage(message)
                        }
                    })
                }, 15000);
                setLocationTimer(interval);
                console.log('Interval set!')
            }
        // }
    }, [clients])

    useEffect(() => {
        // console.log(socket)
        // if(!workerConnected) {
            registerServiceWorker();
        //     localStorage.setItem('workerConnected', true)
        // }
        // if (locationTimer === null && info?.data?.id) {
        //     let { id, firstName, lastName, locationType, location_id } = info.data;
        //     console.log(info)
        //     console.log('Sharing Location!')
        //     const data = {
        //         room: `manager-${locationType}-${location_id}`,
        //         location: { lat: '', lng: '' },
        //         technician: { id, firstName, lastName }
        //     }
        //     let interval = setInterval(() => {
        //         navigator.geolocation.getCurrentPosition((location, err) => {
        //             if(err) {
        //                 console.log(err)
        //             } else {
        //                 data.location.lat = location.coords.latitude;
        //                 data.location.lng = location.coords.longitude;
        //                 console.log(data)
        //                 socket.emit('send_location', JSON.stringify(data))
        //             }
        //         })
        //     }, 30000);
        //     setLocationTimer(interval);
        //     console.log('Timer Set!')
        // }
    }, [ info ])

    return(
        <div className=''>
            <Nav showMenu={showMenu} setShowMenu={setShowMenu} setShowNotification={setShowNotification} />
            <Menu setShowMenu={setShowMenu} showMenu={showMenu} uiConfig={uiConfig}/>
            <Notification showNotification={showNotification} setShowNotification={setShowNotification}/>
            {
                showMenu ? <Menu /> : null
            }
            {
                showLoader && <Loader />
            }
            <Routes>
                <Route path='/profile' element={ <ProfileSetting /> } />
                {/* <Route path='/select_manual' element={ <ManualSelector /> } /> */}
                <Route path='/special_equipments' element={ <SpecialEquipments /> } />
                <Route path='/manual_list' element={ <ManualList /> } />
                <Route path='/make_selector' element={ <MakeSelector /> } />
                <Route path='/model_selector' element={ <ModelSelector /> } />
                <Route path='/manual' element={ <Manual /> } />
                <Route path='/leave' element={ <Leave /> } />
                <Route path='/trainings' element={ <Trainings /> } />
                <Route path='/certifications' element={ <Certification /> } />
                <Route path='/course' element={ <CourseDescription /> } />
                <Route path='/faqs' element={ <ChatGpt /> } /> 
                <Route path='/appointment' element={ <Appointments /> } />
                <Route path='/appointment_details' element={ <AppointmentDetails /> } />
                <Route path='/create_new_appointment' element={ <CreateNewAppointment /> } />
                <Route path="view_estimate" element={<TotalEstimatePreview />} />
                <Route path='/' element={ <Appointments /> } />
                <Route path='/payment_mode' element={<PaymentMode />} />
                <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
                <Route path="/payment-nfc" element={<TapToPay />} />
                <Route path="/payment_page" element={<PaymentPage />} />
                <Route path="/payment_successful" element={<PaymentSuccessful />} />
                <Route path='/support' element={ <ChatSupport /> } />
            </Routes>
        </div>
    )
}

export default Home;
